import { trackLink } from "../../../../../../services/analytics";
import { GOOGLE_ADVERT_LOADED } from "../constants";
import {
  ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE_EVENT,
  ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE
} from "../../../../../../services/analytics/constants";

export const googleAdvertLoaded = state => {
  const newState = {
    ...state,
    trackLink: {
      vars: [ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE],
      events: [ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE_EVENT],
      savedItemAction: GOOGLE_ADVERT_LOADED,
      googleAdvertLoadedAction: "saveditems|google|impression"
    }
  };

  trackLink({ state: newState });

  return newState;
};
